import React from 'react';

interface Img {
  height: number;
  url: string;
  width: number;
}

export interface FbOg {
  amount?: string;
  currency?: string;
  description?: string;
  image?: Img[];
  title?: string;
  type?: string;
}

export interface FbOpenGraphMetadataProps {
  canonicalUrl?: string;
  fbOg?: FbOg;
  pageDescription: string;
  pageTitle: string;
  s3BasePath: string;
}

const FbOpenGraphMetadata: React.FC<FbOpenGraphMetadataProps> = ({
  canonicalUrl,
  pageTitle,
  pageDescription,
  fbOg,
  s3BasePath,
}) => {
  const { type, title, description, amount, currency, image } = (fbOg || {}) as Partial<NonNullable<FbOg>>;

  const logoImg: Img = {
    height: 82,
    url: `${s3BasePath}mkt/logo_small.png`,
    width: 219,
  };
  const defaultValues: FbOg = {
    description: pageDescription,
    image: [logoImg],
    title: pageTitle,
    type: 'website',
  };

  return (
    <>
      {canonicalUrl && <meta content={canonicalUrl} property="og:url" />}
      <meta content={type || defaultValues.type} property="og:type" />
      {(title || defaultValues.title) && (
        <>
          <meta content={title || defaultValues.title} property="og:title" />
          <meta content={title || defaultValues.title} itemProp="name" />
        </>
      )}
      {(description || defaultValues.description) && (
        <>
          <meta content={description || defaultValues.description} property="og:description" />
          <meta content={description || defaultValues.description} itemProp="description" />
        </>
      )}
      {amount && currency && (
        <>
          <meta content={amount} property="product:price:amount" />
          <meta content={currency} property="product:price:currency" />
        </>
      )}
      {(image || defaultValues.image).map(el => (
        <>
          <meta content={el.url} property="og:image" />
          <meta content={el.url} itemProp="image" />
          {el.width && <meta content={el.width.toString()} property="og:image:width" />}
          {el.height && <meta content={el.height.toString()} property="og:image:height" />}
        </>
      ))}
    </>
  );
};
export default FbOpenGraphMetadata;
